import { Conditions } from '../enums/conditions';

export const conditionOptions = [
  { label: Conditions.BU, value: Conditions.BU },
  { label: Conditions.NEW, value: Conditions.NEW },
];